import FileImage               from '@/components/FileImage';
import React                  from 'react';
import StonecodeFileFileModel from '@models/file/StonecodeFileFileModel';

/**
 * Adresse affichable d'un fichier image : son URL s'il est public, sinon son contenu en base64 — les
 * autres sont servis par l'API et exigent les en-têtes d'authentification. `label` n'apparaît que
 * dans le message d'erreur.
 */
export default function useFileImageSrc(file: StonecodeFileFileModel | undefined, label: string) {
	const [src, setSrc] = React.useState<string>();

	React.useEffect(() => {
		if (!file) return setSrc(undefined);
		if (file.public) return setSrc(file.downloadPath);

		let abandonne = false;

		FileImage.fetchBase64ForFile(file)
			.then(base64 => !abandonne && setSrc(String(base64)))
			.catch(err => console.error(label, err));

		return () => {
			abandonne = true;
		};
	}, [file?.id, file?.public, file?.downloadPath]);

	return src;
}
